<template>
  <div class="introduceThree">
      <div class="head">
        <img src="../../assets/advertisement/introduceThree/zt3-pic1.jpg" alt="">
      </div>
      <div class="z_nav" :class="{fix: Fixed}">
        <div class="m_nav">
            <div class="m_nav_r">
                <ul class="choose">
                    <li><a @click="btn1"><span :class="{active: b1_a}">冬蟲夏草藥用價值、滋補功效</span><b :class="{active: b1_a}">居中藥三寶之首</b></a></li>
                    <li><a @click="btn2"><span :class="{active: b2_a}">冬蟲夏草</span><b :class="{active: b2_a}">怎麼吃效果好</b></a></li>
                    <li><a @click="btn3"><span :class="{active: b3_a}">冬蟲夏草低效利用階段的</span><b :class="{active: b3_a}">五大誤區</b></a></li>
                    <li><a @click="btn4"><span :class="{active: b4_a}">極草·5X冬蟲夏草純粉片含著吃</span><b :class="{active: b4_a}">比直接吃原草更具三大優勢</b></a></li>
                </ul>
            </div>
        </div>
    	</div>
			<div class="z_md_one">
				<div class="bankuai-one">
					<div class="show">
						<img src="../../assets/advertisement/introduceThree/zt2_banner.jpg" alt="">
						<p style="color: #000">中醫藥界一直流傳著“中藥三大寶，人參、鹿茸、冬蟲夏草”的說法，冬蟲夏草的藥用價值、滋補功效更是位居三大寶之首。</p>
						<p>冬蟲夏草以其“治諸虛百損”的獨到特點吸引了眾多醫學藥學專家競相研究，各類研究文獻已經超過5000 篇。隨著研究手段與技術的進步，冬蟲夏草功效的物質基礎——功效活性成分及其化學結構不斷地被發現，冬蟲夏草的諸多功效正在被大量藥理試驗和臨床研究證實。素有“百藥之王”的冬蟲夏草，不僅對癌症、糖尿病、肝病、肺病、腎病、過敏性疾病、心腦血管病等疾病的治療有良好的輔助效果，更重要的是，冬蟲夏草強壯補虛與平衡調理作用，在保持健康，降低疾病的發生風險、尤其是降低癌症的發生風險，促進病後的恢復等方面具有確切的功效。</p>
						<p>目前，冬蟲夏草已經不僅僅是單純的傳統中藥，更成為維護健康、提升生命品質的頂級滋補品。</p>
						<p>而且，冬蟲夏草具有陰陽同補的特點，專補命門、能治諸虛百損，老少病虛者皆宜食用。相比人參、鹿茸等，其獨具溫和平補之效，適用人群更為廣泛，使用方法更為簡單。因而，近年來，越來越多的人選擇冬蟲夏草進行滋補養生、疾病治療的輔助與調理。</p>
						<p>冬蟲夏草純粉片發明者——中國·青海春天藥用資源科技利用有限公司已將專利、品牌授予澳門極草生產，並提供技術支持、品質監督。</p>
					</div>
				</div>
				<p class="c_ztbox" style="margin-bottom: 0;"></p>
				<div class="bankuai-two">
					<div class="ban">
						<h3 class="title">二、冬蟲夏草怎麼吃效果最好</h3>
							<div><img src="../../assets/advertisement/introduceThree/zt2_banner_two.jpg" alt=""></div>
							<p>今天，冬蟲夏草的多重應用價值已被現代生物科學明確證實。西方學者研究揭示，冬蟲夏草是天然的化合物寶庫，價值珍貴。諸多應用研究結果表明，古代與現代、東方與西方，對冬蟲夏草價值的認識驚人的一致！</p>
							<p><b>執著於冬蟲夏草的寶貴價值，人們孜孜求索，漸行漸近——配著煎服、泡酒喝、燉著吃、泡水嚼著吃、打粉吃……</b></p>
							<p><b>冬蟲夏草吃法的不斷進化，都是為了一個目的：更多吸收、更好吸收！</b></p>
							<p><b>冬蟲夏草吃法的進化，展現了兩個重大發展趨勢：</b></p>
							<p><b>一是從配伍吃到單獨吃</b></p>
							<p>隨著對冬蟲夏草陰陽同補、自成天然大複方這一獨到特點研究與認識的深入，發現其獨特功能來自於已知和未知的上千種成分自成體系的協同與相互作用，天然的精妙配方，任何添加都可能是多餘的。</p>
							<p><b>二是從高溫加熱吃到直接生吃</b></p>
							<p>加熱超過60℃，冬蟲夏草中的活性酶類、真菌多糖等會被破壞，功效明顯下降。常溫生服，才會有更好的效果。</p>
							<p><b>1. 研究證實</b></p>
							<p><b>常溫生服，是冬蟲夏草最具藥用價值的服用方式</b></p>
							<p>科學研究表明，冬蟲夏草的傳統食用方法不科學，如煲湯、水煎、泡茶等，服用後的效果並不理想。加熱、燉煮，在增加耐熱成分溶出釋放的同時，也會造成冬蟲夏草中多種核心精華成分的損失、破壞，而且吃起來也極不方便。</p>
							<p>現代藥理學研究已經證實，冬蟲夏草中含有多種物質，如蟲草酸、蟲草素、蟲草多糖、胺基酸、蟲草多肽、蛋白質，以及40 余種揮發性物質、多種活性酶類等，很多<b class="black">在溫度高於60℃時會變性、揮發，造成冬蟲夏草功效明顯降低。</b></p>
							<p>Sasaki 等的研究還顯示，多糖的活性與分子量大小有關，分子量大於1.6×10000時，才具有活性。<b>多糖在加熱時，會造成水解、結構改變，多糖的分支減少、分子量下降，其作用亦會明顯下降甚至消失。</b></p>
							<p>冬蟲夏草中含有的<b>某些活性酶類，在80℃下加熱15分鐘後會徹底失活。</b></p>
							<p>專家指出，常溫生服才是冬蟲夏草最具藥用價值的食用方式。</p>
							<p><b>2. 冬蟲夏草常溫生服</b></p>
							<p><b>必須經過淨製達到直接服用級標準，才有安全保障</b></p>
							<div class="flex">
									<div class="flex1">
											<p>淨制達到直接服用級標準的冬蟲夏草</p>
											<img src="../../assets/advertisement/introduceThree/jc_zt_sec2_img1.jpg" alt="">
									</div>
									<div class="flex1">
											<p>冬蟲夏草不清潔滅菌，有巨大健康隱患</p>
											<img src="../../assets/advertisement/introduceThree/jc_zt_sec2_img2.jpg" alt="">
									</div>
							</div>
							<p><b>3. 冬蟲夏草精華成分多蘊含在細胞內，打破細胞結構</b></p>
							<p><b>才能釋放更多、在消化道停留更久，吸收更多才有可能</b></p>
							<p>中藥細胞級微粉碎技術是目前國際先進的粉碎技術，打破細胞結構的微粉化中藥進入體內後，可溶性成分迅速釋放溶解，即使溶解度低的成分也因微粉具有較大的附著力而緊緊粘附在胃腸內壁的黏膜上，使在胃腸道停留時間相對延長，吸收更充分，吸收量也會增加。由於細胞壁大部分在粉碎時被破壞，有效成分不需通過細胞壁和細胞膜就可以釋放，釋放速度和釋放量遠優於普通粉碎。</p>
							<p>普通粉碎的藥材粉末，未能打破細胞結構，有效成分只能通過擴散緩慢地從細胞壁和細胞膜釋放出來。在有限的消化時間內，位於內部細胞中的有效成分有時還來不及釋放就被排出體外，因而常常達不到有效的治療濃度。</p>
							<p>其實，早在1500 年前南北朝梁代陶弘景所著的《本草經集注》就已經對藥物提出“細切”的要求，並指出炮製能影響療效：“藥有易碎難碎，多末少末，秤兩則不復均，今皆細切之，較略今如咀者，差得無末而粒片調於藥力同出，無生熟也”。這表明，古人早已意識到將藥物粉碎達到顆粒均勻，則藥物成分溶出速度相對接近，因此將藥物細切到成分能夠快速均勻溶出，則無所謂生熟，當然，需要熟製的中藥除外。</p>
							<p><b>直接吃原草吸收有限，堅持足量，也需要較長時間才可能會有效。</b></p>
							<p>常溫生服僅僅是第一步，目的是將冬蟲夏草的藥效成分完整地保留。</p>
							<p>服用冬蟲夏草，想要達到物有所值的藥用效果，關鍵在於我們的身體能否獲得足量的藥效成分。</p>
							<p>冬蟲夏草原草泡水嚼著吃、洗洗直接吃，包括用小鋼磨打成粉吃，均無法達到將冬蟲夏草細胞粉碎的程度，蘊含在細胞內的大部分藥效成分都難以有效釋放，能夠被我們身體吸收穫取的量很小，必須堅持足量服用才有效果。</p>
							<p>因此，《中華人民共和國藥典》對冬蟲夏草的建議服用量為3-9克。</p>
							<p style="padding-left:2em;text-indent:0;"><small>參考文獻:</small>
									<br>
									<small>1.Sasaki T,Takasnka N. Chinara G,Maeda YY .Gann, 1976,67, 67 :191--195 .</small>
									<br>
									<small>2.冬蟲夏草菌中酸性非限制性DNA 內切酶的研究. 湖北工業大學學報. 2005,20（1）：12--13.</small>
									<br>
									<small>3.健康時報. 2009 年6 月15 日第16 版</small>
									<br>
									<small>4.微粉化技術在名貴中藥中的應用.中國藥房.2014,25（23）:2192-2193</small>
									<br>
									<small>5.中藥微粉化研究進展. 2009 全國中藥創新與研究論壇論文集：41- 45.</small>
									<br>
									<a name="c"></a>
									<small>6.淺談中藥細胞級粉碎對體內吸收的影響. 齊魯藥事. 2008，27（5）：294- 296.</small>
									<br>
									<small>7.中藥超微粉碎之淺析. 中國中藥雜誌. 2004，29（9）：823- 827.</small>
									<br>
									<small>8.中華人民共和國藥典. 國家藥典委員會編. 中國醫藥科技出版社，2010：106.</small>
							</p>
					</div>
			</div>
			<p class="c_ztbox" style="margin: 0;"></p>
			<div class="bankuai-three" style="padding-top:50px;padding-bottom:50px">
					<img style="width: 1200px;display: block;margin: 0 auto;" src="../../assets/advertisement/introduceThree/zt3-pic3.jpg" alt="">
					<div class="it_flex">
							<div class="it_flex_img"><img src="../../assets/advertisement/introduceThree/jc_zt_sec3_img1.jpg" alt=""></div>
							<div class="it_flex_text">
									<ul>
											<li><b>誤區1 小鋼磨打粉吃</b></li>
											<li>錯誤指數：<span class="f"></span><span class="f"></span><span class="f"></span><span class="f"></span>
													<span class="f"></span>
											</li>
											<li>
													<p>小鋼磨打粉無法打破冬蟲夏草的細胞結構，將蘊含在細胞內的精華釋放，因而達不到期望的明顯提升服用效果的目的，簡易設備製粉時的高溫還會造成精華的流失與破壞，降低功效。</p>
													<p>現場打粉未清潔不滅菌、泥沙殘留、重金屬超標,吃了有極大健康隱患,打粉後也極易發霉、變質、失效!</p>
											</li>
									</ul>
							</div>
					</div>
					<div class="it_flex">
							<div class="it_flex_img"><img src="../../assets/advertisement/introduceThree/jc_zt_sec3_img2.jpg" alt=""></div>
							<div class="it_flex_text">
									<ul>
											<li><b>誤區2 每天幾根泡水嚼著吃</b></li>
											<li>錯誤指數：<span class="f"></span><span class="f"></span><span class="f"></span><span class="h"></span>
													<span class="h"></span>
											</li>
											<li>
													<p>不衛生，危害大。致病細菌、真菌、寄生蟲（卵）殺不死。難洗淨，泥沙殘留、重金屬超標！泡水喝、嚼碎吃，人體能夠吸收的精華成分很有限，要想真正吃得有效，每天幾根的量遠遠不夠！</p>
													<p>《中華人民共和國藥典》對原草的建議服用量為3-9克，3克相當於10根以上中等大小的原草。</p>
											</li>
									</ul>
							</div>
					</div>
					<div class="it_flex">
							<div class="it_flex_img"><img src="../../assets/advertisement/introduceThree/jc_zt_sec3_img3.jpg" alt=""></div>
							<div class="it_flex_text">
									<ul>
											<li><b>誤區3 每天三、五根燉著吃</b></li>
											<li>錯誤指數：<span class="f"></span><span class="f"></span><span class="f"></span><span class="f"></span>
													<span class="h"></span>
											</li>
											<li>
													<p>加熱會破壞冬蟲夏草的多種重要精華成分，比如，冬蟲夏草中的一種具有抗腫瘤作用的酸性非限制性內切酶，在80℃下加熱15分鐘就會徹底失去活性；具有免疫調節和抗腫瘤作用的蟲草多醣成分，在大分子情況下才有作用，加熱和在水中浸泡時間過長，都會使多醣水解，分子變小，其作用下降甚至消失。</p>
													<p>而且，根據藥典和專家的建議，每天三、五根的量是遠不夠的。量不夠，吃了也難以獲得期望的效果！</p>
											</li>
									</ul>
							</div>
					</div>
					<div class="it_flex">
							<div class="it_flex_img"><img src="../../assets/advertisement/introduceThree/jc_zt_sec3_img4.jpg" alt=""></div>
							<div class="it_flex_text">
									<ul>
											<li><b>誤區4 洗洗直接吃</b></li>
											<li>錯誤指數：<span class="f"></span><span class="f"></span><span class="f"></span><span class="f"></span>
													<span class="f"></span>
											</li>
											<li>
													<p>不密封的髒蟲草，未經深度清潔滅菌，絕對不能常溫生服！</p>
													<p>冬蟲夏草表面的“臟東西”與體表粘性極強的菌膜緊緊附著，而且蟲體的皺褶內也隱藏粘附著大量“臟東西”。即使刷洗也很難洗淨，致病細菌、黴菌、寄生蟲(卵) 難去除，泥沙殘留、重金屬超標。浸泡刷洗時間超過3分鐘，部分有效成分將損失50%以上，效果降低。</p>
											</li>
									</ul>
							</div>
					</div>
					<div class="it_flex">
							<div class="it_flex_img"><img src="../../assets/advertisement/introduceThree/jc_zt_sec3_img5.jpg" alt=""></div>
							<div class="it_flex_text">
									<ul>
											<li><b>誤區5 蟲草發霉，處理一下繼續吃</b></li>
											<li>錯誤指數：<span class="f"></span><span class="f"></span><span class="f"></span><span class="f"></span>
													<span class="f"></span>
											</li>
											<li>
													<p>無藥效、易致癌！</p>
													<p>霉變物質的毒性強烈，簡單加熱或酒精處理去不掉，洗洗、曬曬更不可能消除。</p>
													<a name="d"></a>
													<p>研究表明，霉變產生的黃曲霉毒素是強致癌劑，毒性是氰化鉀的10倍，砒霜的68倍，而且，需要280℃以上的高溫才能被破壞。</p>
											</li>
									</ul>
							</div>
					</div>
			</div>
			<p class="c_ztbox" style="margin: 0;"></p>
			<div class="two bankuai-four" style="background-color: #fff;padding-bottom: 80px;">
					<img style="border-top: 4px solid #b8956b;" src="../../assets/advertisement/introduceThree/zt3-pic4.jpg" alt="">
					<ul>
							<li>
									<h3>高效</h3>
									<div>
											<p>同等研究條件下，極草的冬蟲夏草中總物質溶出量遠高於原草。含服瞬間（1 分鐘內）即開始高濃度釋放，這種優勢持續至少60 分鐘，極利於吸收。</p>
											<p>極草將冬蟲夏草製成純粉片，通過含服增加口腔黏膜吸收，精華成分直接進入血液循環，避免首過效應，為提高冬蟲夏草的生物利用度增加了一個快速高效的途徑。</p>
									</div>
							</li>
							<li>
									<h3>安全</h3>
									<div>
											<p>極草產品為工業化生產，每批投料幾十公斤以上，每根原料草均經過嚴格的8 步檢測（真偽、水分、雜質、多元素及重金屬、異物、蟲蛀、傷痕、重量與子座蟲體比例），完成安全性與初步的質量評價，方可進入正式生產工序。</p>
											<p>原料草經專業清洗後，在顯微鏡下逐根檢測潔淨程度，剖開檢查內部，再經異物檢測儀檢測，合格後低溫乾燥滅菌，進入區離粉碎工序。粉碎制得的粉體再經過嚴格全面的質量檢測，合格才能進行壓片。成品還需再依据质量标准进行全项檢測，合格方可出廠。因此，極草產品是非常安全的。</p>
											<p>使用市場上銷售的原草，也應對每一根進行檢查才能放心吃。然而，現在的造假增重手段，即使是專業人士，如果不借助專業儀器與技術，也很難分辨。敬請特別注意！</p>
									</div>
							</li>
							<li>
									<h3>省錢</h3>
									<div>
											<p>按照功效研究確定的有效服用量服用，原草重要成分的溶出比極草純粉含片低很多，日均花費卻遠高於極草：</p>
											<p>《中華人民共和國藥典》對原草的建議服用量為3-9克；</p>
											<p>經功效研究確定並由權威部門批准，極草的推薦服用量為1-3.5克。</p>
									</div>
							</li>
					</ul>

					<div style="margin:20px auto;">
							<img src="../../assets/advertisement/introduceThree/tab.jpg" alt="" style="width:100%;">
					</div>
					<h4 style="color:#494949;font-size:14px;">說明：</h4>
					<p class="small">極草純粉含片比原草至少多7倍精華的溶出，口含吸收帶來了利用度更高、效果更快更好。</p>
					<p class="small">市場上購買的原草，您吃到嘴裡的重量，還得再打個7折。因為在蟲頭部及蟲體皺褶中隱藏著不易看見的泥沙雜質，即使肉眼看起來比較幹淨，但這些隱藏的泥沙雜質，也通常佔原草重量的30%以上。也就是說，去掉這30%無效重量，原草花費至少高達經典含片的1.9倍。</p>
					<p class="small">不僅如此，由於原草水分含量在低於11%時，運輸和銷售中易於折斷損耗，因而市售原草水分含量通常高於14%，比極草純粉片嚴格內控在10%以內的水分含量，又高出至少4%。</p>
					<p class="small">我們在研究中發現，冬蟲夏草原草在水中浸泡一分鐘，藥效成分已經開始有溶出。如果想清洗幹淨，尤其是將蟲體皺褶中的泥沙洗淨，需要浸泡更長的時間，冬蟲夏草有效成分會有大量損失。</p>
					<div style="margin:20px auto;">
							<img src="../../assets/advertisement/introduceThree/jc_zt_sec4_img1.jpg" alt="">
					</div>
			</div>
		</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
			Fixed: false,
			b1_a: true,
			b2_a: false,
			b3_a: false,
			b4_a: false,
		};
  },
  watch: {},
  computed: {},
  methods: {
		handleScroll () {
			var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			var offsetTop = document.querySelector('.z_nav').offsetTop;
			var banTop = document.querySelector('.z_md_one').offsetTop;
			if (Number(scrollTop) + 130 > offsetTop) {
				this.Fixed = true
			} else {
				this.Fixed = false
			};

			var nowTop = Number(scrollTop) + 204;
			var bankuai_one_top = document.querySelector('.bankuai-one').offsetTop;
			var bankuai_two_top = document.querySelector('.bankuai-two').offsetTop;
			var bankuai_three_top = document.querySelector('.bankuai-three').offsetTop;
			var bankuai_four_top = document.querySelector('.bankuai-four').offsetTop;

			if (nowTop > bankuai_one_top && nowTop < bankuai_two_top) {
				this.b2_a = false;
				this.b1_a = true;
				this.b3_a = false;
				this.b4_a = false;
			} else if (nowTop > bankuai_two_top && nowTop < bankuai_three_top) {
				this.b2_a = true;
				this.b1_a = false;
				this.b3_a = false;
				this.b4_a = false;
			} else if (nowTop > bankuai_three_top && nowTop < bankuai_four_top) {
				this.b2_a = false;
				this.b1_a = false;
				this.b3_a = true;
				this.b4_a = false;
			} else if (nowTop > bankuai_four_top) {
				this.b2_a = false;
				this.b1_a = false;
				this.b3_a = false;
				this.b4_a = true;
			}
		},
		btn1 () {
			var b_1_Top = document.querySelector('.bankuai-one').offsetTop;
			window.scrollTo(0,Number(b_1_Top) - 204);
			this.b2_a = false;
			this.b1_a = true;
			this.b3_a = false;
			this.b4_a = false;
		},
		btn2 () {
			var b_2_Top = document.querySelector('.bankuai-two').offsetTop;
			window.scrollTo(0,Number(b_2_Top) - 204);
			this.b2_a = true;
			this.b1_a = false;
			this.b3_a = false;
			this.b4_a = false;
		},
		btn3 () {
			var b_3_Top = document.querySelector('.bankuai-three').offsetTop;
			window.scrollTo(0,Number(b_3_Top) - 204);
			this.b2_a = false;
			this.b1_a = false;
			this.b3_a = true;
			this.b4_a = false;
		},
		btn4 () {
			var b_4_Top = document.querySelector('.bankuai-four').offsetTop;
			window.scrollTo(0,Number(b_4_Top) - 204);
			this.b2_a = false;
			this.b1_a = false;
			this.b3_a = false;
			this.b4_a = true;
		}
	},
  created() {
    window.scrollTo(0,0)
	},
  mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed () {
  	window.removeEventListener('scroll', this.handleScroll);
	}
};
</script>
<style scoped>
@import "../../css/introduceThree.css";

.fix {
	position: fixed;
	top: 130px;
}

.active {
	color: #9c0001;
}
</style>



// WEBPACK FOOTER //
// src/pages/advertisement/IntroduceThree.vue